import { HTMLColor } from "../colors/HTMLColor";
import { HTMLColorParser } from "../colors/HTMLColorParser";
import { RGBColor } from "../colors/RGBColor";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { HTMLEditor } from "../dom-tools/HTMLEditor";
import { Arrays } from "../tools/Arrays";

export class GradientText
{
  static readonly attribute = new ElementAttribute( "-gradient--text" );

  static applyOnDocument()
  {
    GradientText.attribute.forEachInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    
    let colorValue = window.getComputedStyle( e ).color;
    let color = HTMLColorParser.fromString( colorValue );
    
   
    var w = 20;
    var l = 5;
    var s = 3;

    let startColor = color.clone().toHSL().warmen( w ).lighten( l ).saturate( -s );
    let endColor   = color.clone().toHSL().warmen( -w ).lighten( -l ).saturate( s );

    // console.log( "GRADIENT TEXT:", e, colorValue, color, startColor, endColor );
    
    let children = HTMLEditor.splitText( e );

    children = children.filter( c => ! c.textContent.match( /^\s$/ ) );

    Arrays.forEachIndex( children, 
      ( c:HTMLElement, i, n )=>
      {

        let lerpedColor = RGBColor.lerp( startColor, endColor, n );
        let colorString = lerpedColor + "";
        c.style.color = colorString;
      }
    );
  }
}